import { CommunityDocumentQuery } from '../../src/community'

export type SortTypes =
  | 'rcmd' // 추천순
  | 'ratingCount' // 후기 많은 순
  | 'endTime' // 마감 임박순
  | 'hotRating' // 인기순
  | 'rating' // 평점순
  | 'costHigh' // 가격 높은 순
  | 'costLow' // 가격 낮은 순

export interface SearchCommunityDocumentFilter extends CommunityDocumentQuery {
  keyword: string
}

export type SearchEventParam = {
  treatmentIdList?: string
  hospitalId?: number
  start?: number
  length?: number
  sort?: SortTypes
  lat?: number
  lng?: number
  radius?: number
  districtCodeList?: string[]
  keyword?: string
  q?: string
  treatmentCategoryTagIdList?: string
  treatmentGroupIdList?: number[]
  searchTreatmentCategoryId?: number
  filterTreatmentIds?: number[]
  hospitalBadgeCodeList?: string[]
  excludeEventIds?: number[]
  costUpLimit?: number
  costLowLimit?: number
  isPurchasable?: boolean
  isSATDiscount?: boolean
  isExclusivePrice?: boolean
  offlinePointRedemptionEnabled?: boolean
  showAd?: boolean
  isCurrentLocation?: boolean
  type?: string
}

export interface RelatedTreatment {
  id: number
  adId: number | null
  title: string
  titleImage: string
  cardImage: string
  summary: string
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  pageType: 'EVENT' | string
  hospitalId: number
  hospitalName: string
  hospitalSubway?: string
  hospitalSubwayCode: string
  hospitalSigunguCode: string
  ratingCount: number
  rating: number
  ratingShow: boolean
  originalMoney: {
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    currency: 'KRW' | 'JPY' | string
    amount: number
  }
  discountedMoney?: {
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    currency: 'KRW' | 'JPY' | string
    amount: number
  }
  cost: number
  discountedCost: number
  badgeList?: {
    badgeType: string
  }[]
  hospital: {
    id: number
    name: string
    sido: string
    sigungu: string
    sigunguCode: string
    badgeCodeList: string[]
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    country: 'KR' | 'JP' | string
    subwayCode: string
    assessmentState: 'CERTIFIED' | 'GROWTH' | 'EFFORT' | null
    lat: number
    lng: number
  }
  hospitalInfo?: {
    id: number // 660
    name: string // '루호성형외과'
    sido: string // '서울'
    sigungu: string // '강남구'
    sigunguCode: string // '11680'
    badgeCodeList: string[] // ['HB01', 'HB04', 'HB06', 'HB09', 'HB08', 'HB05', 'HB07']
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    country: 'KR' | 'JP' | string
    subwayCode: string // 'SUB_S3_337'
    assessmentState: 'CERTIFIED' | 'GROWTH' | 'EFFORT' | null
    lat: number // 37.5168560197204
    lng: number // 127.01979818833
  }
  hasZzimed: boolean
  zzimCount: number | null
  viewCount: number
  version: number
  opTagList: string[]
  opSubTagList: string[]
  operationTagList: string[]
  treatmentIdList: number[]
  treatmentList: {
    id: number
    name: string
    label: string
  }[]
  treatmentCategoryTagList: {
    id: number
    name: string
    label: string | null
    tagMeta: {
      name: string
      nameKr: string
    }
  }[]
  showVatBadge: boolean
  createTime: number
  updateTime: number
  serviceOfferType: string
  isPurchasable: boolean
  eventPrice: {
    original: {
      currency: 'KRW' | 'JPY'
      amount: number
    }
    discount: {
      currency: 'KRW' | 'JPY'
      amount: number
    }
  }
}

/**
 * 카카오 주소 API Type
 * @see https://developers.kakao.com/docs/latest/ko/local/dev-guide#address-coord
 */
export interface queryAddressCriteria {
  query: string
  analyze_type?: 'similar' | 'exact'
  page?: number
  size?: number
}

export interface Document {
  address: {
    address_name: string
    b_code: string
    h_code: string
    main_address_no: string
    mountain_yn: string
    region_1depth_name: string
    region_2depth_name: string
    region_3depth_h_name: string
    region_3depth_name: string
    sub_address_no: string
    x: string
    y: string
  }
  address_name: string
  address_type: string
  road_address: {
    address_name: string
    building_name: string
    main_building_no: string
    region_1depth_name: string
    region_2depth_name: string
    region_3depth_name: string
    road_name: string
    sub_building_no: string
    underground_yn: string
    x: string
    y: string
    zone_no: string
  }
  x: string
  y: string
}

export interface Address {
  documents: Document[]
  meta: {
    is_end: boolean
    pageable_count: number
    total_count: number
  }
}

export interface SuggestionContextResponse {
  ctype: SuggestionCType
  cname: string
  cvalue: number
  csub: string
}

export enum SuggestionCType {
  TREATMENT_CATEGORY_TAG = 'TREATMENT_CATEGORY_TAG',
  TREATMENT = 'TREATMENT',
  HOSPITAL = 'HOSPITAL',
  DOCTOR = 'DOCTOR',
}
